import axios from 'axios';

const getUfPage = params => axios.get('/open/estados/page', { params });

export default {
  getUfPage,
};
